import { CALL_SIDEBAR_WIDTH, CALL_SIDEBAR_PERMANENT_ELEMENTS_HEIGHT } from '../models/ui/call/constants';
// Numeric breakpoint types
export enum NumericBreakpoint {
  Tiny        = 0,
  ExtraNarrow = 1,
  Narrow      = 2,
  Medium      = 3,
  Wide        = 4,
  ExtraWide   = 5,
}

/**
 * Media query breakpoints, in pixels.
 *
 * If a component's width is >= a *_BREAKPOINT constant, the component should switch to that layout.
 * For example, if the daily news page's width is >= DAILY_NEWS_PAGE_WIDE_BREAKPOINT, it should
 * switch to its wide layout, and use a default layout otherwise.
 *
 * Remember to always check width conditions in order from wide to narrow. (Maybe we should make a
 * helper for this).
 */
export const DEFAULT_WIDE_BREAKPOINT = 770;
export const DEFAULT_MEDIUM_BREAKPOINT = 600;

export const DAILY_NEWS_EXTRA_WIDE_BREAKPOINT = 2000;
export const DAILY_NEWS_WIDE_BREAKPOINT = 1600;
export const DAILY_NEWS_MEDIUM_BREAKPOINT = 950;
export const DAILY_NEWS_NARROW_BREAKPOINT = 700;
export const DAILY_NEWS_EXTRA_NARROW_BREAKPOINT = 450;

export const FOOTER_WIDE_BREAKPOINT = 950;
export const FOOTER_MEDIUM_BREAKPOINT = 700;

export const MINIMUM_DESIRED_CONTENT_WIDTH = 320; // iPhone 5 width
export const CALL_LAYOUT_WIDE_BREAKPOINT = MINIMUM_DESIRED_CONTENT_WIDTH + CALL_SIDEBAR_WIDTH;

// The minimum amount of chat history in pixels that should be visible
const MINIMUM_CALL_SIDEBAR_CHAT_HISTORY_HEIGHT = 88;
export const CALL_LAYOUT_WIDE_VERITCAL_BREAKPOINT =
  CALL_SIDEBAR_PERMANENT_ELEMENTS_HEIGHT + MINIMUM_CALL_SIDEBAR_CHAT_HISTORY_HEIGHT;

export const HTTP_STATUS_PAGE_MEDIUM_BREAKPOINT = 500;
